const AllTeamsTypes = {
    GET_ALL_TEAMS_START:'GET_ALL_TEAMS_START',
    GET_ALL_TEAMS_SUCCESS:'GET_ALL_TEAMS_SUCCESS',
    GET_ALL_TEAMS_FAILED:'GET_ALL_TEAMS_FAILED',

}

export default AllTeamsTypes